<template>
  <el-dialog :title="isEdit ? '修改学期' : '新增学期'" :visible.sync="show" width="800px" center :close-on-click-modal="false" :close-on-press-escape="false" :show-close="!loading" append-to-body>
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
      <el-form-item class="w50" label="学年" prop="schoolyear">
        <el-input v-model="form.schoolyear" placeholder="例如：2019-2020" clearable></el-input>
      </el-form-item>
      <el-form-item class="w50" label="学期" prop="semester">
        <el-select v-model="form.semester" placeholder="请选择学期">
          <el-option label="第一学期" value="1"></el-option>
          <el-option label="第二学期" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="w50" label="开学时间" prop="starttime">
        <el-date-picker v-model="form.starttime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择开学时间"></el-date-picker>
      </el-form-item>
      <el-form-item class="w50" label="结束时间" prop="endtime">
        <el-date-picker v-model="form.endtime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择结束时间"></el-date-picker>
      </el-form-item>
      <el-form-item class="w80" label="说明" prop="explains">
        <el-input type="textarea" :rows="5" placeholder="可输入当学期相关内容" v-model="form.explains"></el-input>
      </el-form-item>
      <el-form-item class="w80">
        <el-button type="primary" @click="validate" :loading="loading">{{ isEdit ? '保存' : '新增' }}</el-button>
        <el-button @click="show = false" :loading="loading">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "EditTermDialog",
  components: {},
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      show: false,

      isEdit: true,
      form: {
        wid: "",
        schoolyear: "",
        semester: "1",
        starttime: null,
        endtime: null,
        explains: ""
      },
      rules: {
        schoolyear: [
          { required: true, message: "请输入学期", trigger: "blur" }
        ],
        semester: [{ required: true, message: "请选择学期", trigger: "blur" }],
        starttime: [
          { required: true, message: "请选择开学时间", trigger: "blur" }
        ],
        endtime: [
          { required: true, message: "请选择结束时间", trigger: "blur" }
        ]
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    newData() {
      this.loading = true;
      this.$http
        .post("/calendar/save", JSON.stringify(this.form), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.$message.success(data.resMsg);
            this.show = false;

            this.$emit("init-page");
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    edidData() {
      this.loading = true;
      this.$http
        .post("/calendar/update", JSON.stringify(this.form), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          if (data.resCode == "0") {
            this.$message.success(data.resMsg);
            this.show = false;

            this.$emit("fetch-list");
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    validate() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isEdit) {
            // 修改
            this.edidData();
          } else {
            // 新增
            this.newData();
          }
        } else {
          return false;
        }
      });
    },
    showView(item, isEdit) {
      this.isEdit = isEdit;
      this.show = true;
      if (item) {
        this.form.wid = item.wid;
        this.form.schoolyear = item.schoolyear;
        this.form.semester = item.semester;
        this.form.starttime = this.$options.filters.filterDate(
          item.starttime,
          "yyyy-MM-dd"
        );
        this.form.endtime = this.$options.filters.filterDate(
          item.endtime,
          "yyyy-MM-dd"
        );
        this.form.explains = item.explains;
      } else {
        this.$nextTick(() => {
          this.$refs.ruleForm.resetFields();
        });
      }
    }
  }
};
</script>

<style scoped>
</style>
